import * as React from 'react';

import { useDispatch } from 'react-redux';
import { setDispensaries } from '../actions/cartActions';
import { fetchDispensaries } from '../dispensaries/dispensary-utils';
import { trackEvent } from '../analytics/tracking';

// In case we have no valid id
const DISPENSARY_NOT_AVAILABLE = -1;

export const DispensariesContext = React.createContext();

const DispensariesProvider = ({dispensaryId=DISPENSARY_NOT_AVAILABLE, children}) => {
  
  const [currentDispensaries, setCurrentDispensaries] = React.useState();
  const [dispensaryIds, setDispensaryIds] = React.useState([]);
  const [dispensaryMap, setDispensaryMap] = React.useState(new Map());
  const [loading, setLoading] = React.useState();

  // Handle missing/disabled dispensaries
  const [dispensariesNotFound, setDispensariesNotFound] = React.useState();
  const dispatch = useDispatch(); 

  const callback = React.useCallback((response) => {
    console.log('DispensariesProvider Callback');
    const data = response.data;
    if (data.length) {
      const mapById = data.reduce((map, dispensary) => map.set(dispensary.id, dispensary), new Map());
      // but not in the id array (used for lists)
      const activeDispensaries = data.filter(dispensary => dispensary.is_accepting_orders);
      const activeIds = activeDispensaries.reduce((active, disp) => {
        if (disp.is_accepting_orders) {
          active.push(disp.id);
        }
        return active;
      }, []);  
      setCurrentDispensaries(activeDispensaries);
      setDispensaryIds(activeIds);
      setDispensaryMap(mapById);
      // update redux for older code
      dispatch(setDispensaries(data));
    } else {
      setDispensariesNotFound(true);
      trackEvent('error_dispensaries_provider');
    }
    setLoading(false);
  }, [dispatch]);
 
  const abortControllerRef = React.useRef(new AbortController());
  // Fetch Dispensaries
  React.useEffect(() => {
    const controller = abortControllerRef.current;
    if (typeof dispensaries === "undefined" && !dispensariesNotFound) { 
      setLoading(true);
      fetchDispensaries(callback, controller);
    }
    // cancel fetch on unmount
    return () => controller.abort();
  }, [currentDispensaries, dispensariesNotFound, callback, abortControllerRef]);

  return <DispensariesContext.Provider value={{
      dispensaries: currentDispensaries,
      dispensaryIds,
      dispensaryMap,
      loading
    }}>
    {children}
  </DispensariesContext.Provider>
}

export default DispensariesProvider;